import { PaintedScene } from '../PaintedScene';

export const CARAVANSERAI_INTERIOR_PHASER_KEY = 'CaravanseraiInteriorScene' as const;
export const CARAVANSERAI_INTERIOR_MANIFEST_KEY = 's-209-caravanserai-interior' as const;

export class CaravanseraiInteriorScene extends PaintedScene {
  constructor() {
    super(CARAVANSERAI_INTERIOR_PHASER_KEY, CARAVANSERAI_INTERIOR_MANIFEST_KEY);
  }
}
